enum LocalStorageKeys {
    SKY_NET_ALL_TABLES_KEY = 'SkyNetAllDataGridsState',
    SKY_NET_ALL_ACCORDION_DASHBOARD_KEY = 'SkyNetAllDashboardItemsState',
}

export default LocalStorageKeys
